module.exports = __webpack_public_path__ + "static/media/modal-contract.b4e9a156.svg";